import { useCallback, useRef, useState } from "react";
import TemporaryDrawer from "../ui/temp-drawer.component";
import { disableBodyScroll, enableBodyScroll } from "../../utils/HtmlHelper";
import { memo } from 'react';
import { CoinIcon } from "../ui/coin-icon";
import { useGetMoneyAmountQuery } from "../../apis/game-income.api";
import { toastCustomError } from "../../utils/ToastUtils";

interface TradingAmountProps {
  tradeAmount: number;
  setAmount: (newAmount: number) => void;
}

const TradingAmount: React.FC<TradingAmountProps> = ({tradeAmount, setAmount}) => {

  return (
    <div className="h-full flat-card flex flex-col justify-between !p-4">
      <CryptoInformation/>
      {/* <AmountTrade amount={tradeAmount}/> */}
      <AmountTradeSelector amount={tradeAmount} setAmount={setAmount}/>
    </div>
  );
}

export default TradingAmount;


const CryptoInformation: React.FC = () => {

  const cryptoLogo = 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png';
  const cryptoName = 'Bitcoin';
  const cryptoCode = 'BTC';

  return (

    <div className="flex justify-start items-center gap-2 w-[142px]">

      <img className="w-10 h-10 img-coin-like" src={cryptoLogo} />

      <div className="flex flex-col">

        <p className="text-2xl">{cryptoName}</p>
        <p className="text-base text-grey-200">{cryptoCode}</p>

      </div>

    </div>
  );
}

interface AmountTradeProps {
  amount: number
}

const AmountTrade: React.FC<AmountTradeProps> = ({amount}) => {

  return (
    <div className="w-full">

      <p className="text-left text-base text-gray-700">Trade amount</p>

      <div className="flex center gap-1 w-full">

        <div className="flex center gap-1 grow">

          <CoinIcon h={20}/>

          <p className='text-2xl'>
            {amount.toLocaleString(undefined, {maximumFractionDigits: 0})}
          </p>

        </div>

        <button className="bg-black medium-button-icon flex center justify-center">

          <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.99979 0C4.26498 5.66374e-05 4.51929 0.105451 4.70679 0.293L7.70679 3.293C7.88894 3.4816 7.98974 3.7342 7.98746 3.9964C7.98518 4.2586 7.88001 4.50941 7.6946 4.69482C7.5092 4.88023 7.25838 4.9854 6.99619 4.98767C6.73399 4.98995 6.48139 4.88916 6.29279 4.707L3.99979 2.414L1.70679 4.707C1.51818 4.88916 1.26558 4.98995 1.00339 4.98767C0.741188 4.9854 0.490376 4.88023 0.304968 4.69482C0.11956 4.50941 0.0143906 4.2586 0.0121121 3.9964C0.00983372 3.7342 0.110629 3.4816 0.292787 3.293L3.29279 0.293C3.48028 0.105451 3.73459 5.66374e-05 3.99979 0ZM0.292787 9.293C0.480314 9.10553 0.734622 9.00021 0.999786 9.00021C1.26495 9.00021 1.51926 9.10553 1.70679 9.293L3.99979 11.586L6.29279 9.293C6.48139 9.11084 6.73399 9.01005 6.99619 9.01233C7.25838 9.0146 7.5092 9.11977 7.6946 9.30518C7.88001 9.49059 7.98518 9.7414 7.98746 10.0036C7.98974 10.2658 7.88894 10.5184 7.70679 10.707L4.70679 13.707C4.51926 13.8945 4.26495 13.9998 3.99979 13.9998C3.73462 13.9998 3.48031 13.8945 3.29279 13.707L0.292787 10.707C0.105316 10.5195 0 10.2652 0 10C0 9.73484 0.105316 9.48053 0.292787 9.293Z" fill="#F9FAFB"/>
          </svg>

        </button>

      </div>
    </div>
  );
}

interface AmountTradeSelectorProps {
  amount: number;
  setAmount: (newAmount: number) => void;
}

const AmountTradeSelector = memo<AmountTradeSelectorProps>(({amount, setAmount}) => {

  const selectAmountValues = [10, 50, 100, 250, 500, 1000];

  const [openDrawer, setOpenDrawer] = useState(false);
  const {data: money} = useGetMoneyAmountQuery();

  const handleOnClick = useCallback((amount: number) => {
    const maxAmount = Math.min(amount, money?.amount || 0);
    setAmount(maxAmount);
    setOpenDrawer(false);
  }, [setAmount, money]);

  return (
    <TemporaryDrawer
      title={'Trading amount'}
      anchor={'bottom'}
      size={'auto'}
      className={'w-full flex mt-2'}
      buttonClass={"w-full "}
      element={
        <div className="w-full" onClick={() => setOpenDrawer(true)}>
          <AmountTrade amount={amount}/>
        </div>
      }
      open={openDrawer}
      onOpen={() => {
        disableBodyScroll();
        setOpenDrawer(true);
      }}
      onClose={() => {
        enableBodyScroll();
        setOpenDrawer(false)
      }}
    >

      <div className={"w-full h-full overflow-y-auto"}>

        <h3 className="text-2xl center">Select the amount to trade</h3>

        <div className="w-3/4 mx-auto">

          {/* Amount values */}
          { money &&
            <div className="grid grid-cols-3 gap-x-3 gap-y-6 my-6">

              { selectAmountValues.map((value, index) => (

                <div key={index} className="w-full h-10 bg-grey-100 rounded center mx-auto"
                  onClick={() => {
                    if ( value <= money.amount ) {
                      handleOnClick(value);
                    } else {
                      toastCustomError("Not enough available money");
                    }
                  }}
                >
                  <p className="text-grey-700 text-xs">{value}</p>
                </div>

              )) }
            </div>
          }

        </div>

          {/* Memoized Input Field */}
          { money &&
            <InputWithIcon initialValue={amount} maxValue={money.amount} handleValidate={handleOnClick}/>
          }

      </div>

    </TemporaryDrawer>
  );
});

interface InputWithIconProps {
  initialValue: number,
  maxValue: number,
  handleValidate: (amount: number) => void
}

// Memoized InputWithIcon component
const InputWithIcon = memo<InputWithIconProps>(({initialValue, maxValue, handleValidate}) => {

  const [inputValue, setInputValue] = useState(initialValue);

  const handleClear = useCallback(() => {
    setInputValue(100);
  }, []);

  const handleChange = useCallback((e:any) => {
    setInputValue(e.target.value);
  }, []);

  const handleValidateAmount = useCallback((amount: number) => {
    handleValidate(Math.max(0, amount));
  }, []);

  return (

    <div className="w-full">

      <div className="w-3/4 mx-auto flex items-center border-4 border-grey-100 rounded-lg gap-1 py-1">

        <div className="px-1">
          <CoinIcon h={24}/>
        </div>

        <div className="grow">
          <input
            type="number"
            className="w-1 min-w-full p-0 border-none focus:border-none focus:outline-none text-2xl !font-bold"
            value={inputValue}
            onChange={handleChange}
            min={0}
            max={maxValue}
          />
        </div>

        <button onClick={handleClear} className="px-3 text-gray-500">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6.707 5.293C6.5184 5.11084 6.2658 5.01005 6.0036 5.01233C5.7414 5.0146 5.49059 5.11977 5.30518 5.30518C5.11977 5.49059 5.0146 5.7414 5.01233 6.0036C5.01005 6.2658 5.11084 6.5184 5.293 6.707L6.586 8L5.293 9.293C5.19749 9.38525 5.12131 9.49559 5.0689 9.6176C5.01649 9.7396 4.9889 9.87082 4.98775 10.0036C4.9866 10.1364 5.0119 10.2681 5.06218 10.391C5.11246 10.5139 5.18671 10.6255 5.2806 10.7194C5.3745 10.8133 5.48615 10.8875 5.60905 10.9378C5.73194 10.9881 5.86362 11.0134 5.9964 11.0123C6.12918 11.0111 6.2604 10.9835 6.3824 10.9311C6.50441 10.8787 6.61475 10.8025 6.707 10.707L8 9.414L9.293 10.707C9.4816 10.8892 9.7342 10.99 9.9964 10.9877C10.2586 10.9854 10.5094 10.8802 10.6948 10.6948C10.8802 10.5094 10.9854 10.2586 10.9877 9.9964C10.99 9.7342 10.8892 9.4816 10.707 9.293L9.414 8L10.707 6.707C10.8892 6.5184 10.99 6.2658 10.9877 6.0036C10.9854 5.7414 10.8802 5.49059 10.6948 5.30518C10.5094 5.11977 10.2586 5.0146 9.9964 5.01233C9.7342 5.01005 9.4816 5.11084 9.293 5.293L8 6.586L6.707 5.293Z" fill="#3F3F46"/>
          </svg>
        </button>

      </div>

      <div className="center mt-6 mb-8 max-w-md mx-auto">
        <button className="primary w-full" onClick={()=>handleValidateAmount(inputValue)}>Validate</button>
      </div>

    </div>

  );
  });